/**
 * Bridge for showing Nuxt UI toasts outside of component setup context
 * (axios interceptors, composables running in non-component scope).
 *
 * App.vue registers the real `useToast()` handler once on startup.
 */
export interface AppToastOptions {
  color: 'error' | 'success' | 'warning' | 'info';
  title: string;
  description?: string;
}

type ToastHandler = (options: AppToastOptions) => void;

let toastHandler: ToastHandler | null = null;

export function registerToastHandler(handler: ToastHandler): void {
  toastHandler = handler;
}

export function showToast(options: AppToastOptions): void {
  toastHandler?.(options);
}
